
import { Vue, Component } from "vue-property-decorator";
import { formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { BarcodeOrderResource } from "@/models/api/barcodeSystem/barcodeOrders/get";
import BarcodeOrderReceiving from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderReceiving.vue"
import BarcodeOrderRereceiving from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderRereceiving.vue"
import BarcodeOrderDelivering from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderDelivering.vue"
import { ReceiveBarcodeOrderRequest } from "@/models/api/barcodeSystem/barcodeOrders/receive";
import { DeliverBarcodeOrderRequest } from "@/models/api/barcodeSystem/barcodeOrders/deliver";
import { RereceiveBarcodeOrderRequest } from "@/models/api/barcodeSystem/barcodeOrders/rereceive";
import notifications from "@/lib/notifications";
const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component({
  components: {
    BarcodeOrderReceiving,
    BarcodeOrderRereceiving,
    BarcodeOrderDelivering
  }
})
export default class BarcodeOrderHeader extends Vue {
  showReceiveOrderModal: boolean = false;
  showDeliverOrderModal: boolean = false;
  showRereceiveOrderModal: boolean = false;
  receivingLoading: boolean = false;
  deliveryLoading: boolean = false;
  rereceivingLoading: boolean = false;
  receiveBarcodeOrderRequest: ReceiveBarcodeOrderRequest = null;
  deliverBarcodeOrderRequest: DeliverBarcodeOrderRequest = null;
  rereceiveBarcodeOrderRequest: RereceiveBarcodeOrderRequest = null;
  receivingValidationMessages: string[] = null;
  deliveringValidationMessages: string[] = null;
  rereceivingValidationMessages: string[] = null;
  
  get currentBarcodeOrder(): BarcodeOrderResource {
    return barcodeOrderModuleState.currentBarcodeOrder;
  }

  get isAgentObject() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder ? barcodeOrderModuleState.currentBarcodeOrder.isAgentObject : false;
  }

  get crn(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.crn
      : ""; 
  }

  get companyName(): string {
    return barcodeOrderModuleState.currentBarcodeOrder && barcodeOrderModuleState.currentBarcodeOrder.company
      ? barcodeOrderModuleState.currentBarcodeOrder.company.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.displayBillToCompanyId
      : ""; 
  }

  set displayBillToCompanyId(val: string){
  }

  get orderNumber(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }  
  
  get deliveryType(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.deliveryType
      : ""; 
  }

  set deliveryType(val: string){
  }

  get status(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.status
      : ""; 
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.statusDescription
      : ""; 
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get importedDateTimeFormatted(): string {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.importedDate)
      : "";
  }

  set importedDateTimeFormatted(val: string){
  }

  get receivedDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder
      ? formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.receivedDate)
      : "";
  }

  set receivedDateTimeFormatted(val: string){
  }

  get receivingProcessedDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder && barcodeOrderModuleState.currentBarcodeOrder.receivingProcessedDate
      ? 'Processed on ' + formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.receivingProcessedDate) + (barcodeOrderModuleState.currentBarcodeOrder.receivingUsername ? ' by ' + barcodeOrderModuleState.currentBarcodeOrder.receivingUsername : '')
      : "";
  }

  set receivingProcessedDateTimeFormatted(val: string){
  }

  get loadedDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder
      ? formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.loadedDate)
      : "";
  }

  set loadedDateTimeFormatted(val: string){
  }

  get loadingProcessedDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder && barcodeOrderModuleState.currentBarcodeOrder.loadingProcessedDate
      ? 'Processed on ' + formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.loadingProcessedDate) + (barcodeOrderModuleState.currentBarcodeOrder.loadingUsername ?  + ' by ' + barcodeOrderModuleState.currentBarcodeOrder.loadingUsername : '')
      : "";
  }

  set loadingProcessedDateTimeFormatted(val: string){
  }

  get deliveredDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder
      ? formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.deliveredDate)
      : "";
  }

  set deliveredDateTimeFormatted(val: string){
  }

  get deliveryProcessedDateTimeFormatted(): string{
    return barcodeOrderModuleState.currentBarcodeOrder && barcodeOrderModuleState.currentBarcodeOrder.deliveryProcessedDate
      ? 'Processed on ' + formatDateWithTime(barcodeOrderModuleState.currentBarcodeOrder.deliveryProcessedDate) + (barcodeOrderModuleState.currentBarcodeOrder.deliveryUsername ?  + ' by ' + barcodeOrderModuleState.currentBarcodeOrder.deliveryUsername : '')
      : "";
  }

  set deliveryProcessedDateTimeFormatted(val: string){
  }

  get requiresPicking() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.requiresPicking
      : false;
  }

  get requiresReceiving() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.requiresReceiving
      : false;
  }

  get requiresDelivery() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.requiresDelivery
      : false;
  }

  get requiresRereceiving() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder
      ? barcodeOrderModuleState.currentBarcodeOrder.requiresRereceiving
      : false;
  }
  
  get isReceiveable() : boolean
  {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.isReceiveable
      : false;
  }
  
  get isRereceiveable() : boolean
  {
    return this.rereceiveBarcodeOrderRequest
      ? this.rereceiveBarcodeOrderRequest.isRereceiveable
      : false;
  }
  
  get isDeliverable() : boolean
  {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.isDeliverable
      : false;
  }

  async receivePrompt()
  {
    this.receiveBarcodeOrderRequest = null;
    this.receivingLoading = true;
    this.showReceiveOrderModal=true;
    this.receiveBarcodeOrderRequest = await barcodeOrderModuleState.previewReceiveBarcodeOrder(this.currentBarcodeOrder.id);
    this.receivingLoading = false;
  }  
  
  async deliverPrompt()
  {
    this.deliverBarcodeOrderRequest = null;
    this.deliveryLoading = true;
    this.showDeliverOrderModal=true;
    this.deliverBarcodeOrderRequest = await barcodeOrderModuleState.previewDeliverBarcodeOrder(this.currentBarcodeOrder.id);
    this.deliveryLoading = false;
  }

  async rereceivePrompt()
  {    
    this.rereceiveBarcodeOrderRequest = null;
    this.rereceivingLoading = true;
    this.showRereceiveOrderModal=true;
    this.rereceiveBarcodeOrderRequest = await barcodeOrderModuleState.previewRereceiveBarcodeOrder(this.currentBarcodeOrder.id);
    this.rereceivingLoading = false;
  } 

  closeModals()
  {
    this.showReceiveOrderModal=false;
    this.showDeliverOrderModal=false;
    this.showRereceiveOrderModal = false;
  }

  async receiveOrder() {
    if(this.validateReceiving())
    {
      this.receivingLoading = true;
      try {
        await barcodeOrderModuleState.receiveBarcodeOrder(
          this.receiveBarcodeOrderRequest
        );
        notifications.success("Barcode Order Received", "Barcode Order successfully received.");
        this.$emit("reload");
        this.closeModals();
      } catch (ex) {
        notifications.error("Receiving Barcode Order", "Failed to receive barcode orders", ex);
      } finally {
        this.receivingLoading = false;
      }
    }
  }

  validateReceiving() : boolean {
    let valid = this.receiveBarcodeOrderRequest != null;
    this.receivingValidationMessages = null;

    if(!valid)
      return false;

    if(this.receiveBarcodeOrderRequest.orderItems.some(x => x.damaged && x.quantityDamaged <= 0)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.receivingValidationMessages = [];
      this.receivingValidationMessages.push('All damaged items must have a quantity damaged greater than 0.'); 
    }
    if(this.receiveBarcodeOrderRequest.orderItems.some(x => x.damaged && !x.damageCode)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.receivingValidationMessages = [];
      this.receivingValidationMessages.push('All damaged items must have a selected damage code.');
    }
    if(this.receiveBarcodeOrderRequest.orderItems.some(x => x.quantityReceived > x.quantity)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.receivingValidationMessages = [];
      this.receivingValidationMessages.push('Quantity received cannot be greater than an items quantity.');
    }
    return valid;
  }

  async deliverOrder() {
    if(this.validateDelivering())
    {
      this.deliveryLoading = true;
      try {
        await barcodeOrderModuleState.deliverBarcodeOrder(
          this.deliverBarcodeOrderRequest
        );
        notifications.success("Barcode Order Delivered", "Barcode Order successfully delivered.");
        this.$emit("reload");
        this.closeModals();
      } catch (ex) {
        notifications.error("Delivering Barcode Order", "Failed to deliver barcode orders", ex);
      } finally {
        this.deliveryLoading = false;
      }
    }
  }

  validateDelivering() : boolean {
    let valid = this.deliverBarcodeOrderRequest != null;
    this.deliveringValidationMessages = null;

    if(!valid)
      return false;

    if(this.deliverBarcodeOrderRequest.orderItems.some(x => x.damaged && x.quantityDamaged <= 0)) {
      valid = false;
      if(!this.deliveringValidationMessages)
        this.deliveringValidationMessages = [];
      this.deliveringValidationMessages.push('All damaged items must have a quantity damaged greater than 0.'); 
    }
    if(this.deliverBarcodeOrderRequest.orderItems.some(x => x.damaged && !x.damageCode)) {
      valid = false;
      if(!this.deliveringValidationMessages)
        this.deliveringValidationMessages = [];
      this.deliveringValidationMessages.push('All damaged items must have a selected damage code.');
    }
    if(this.deliverBarcodeOrderRequest.orderItems.some(x => x.quantityDelivered > x.quantity)) {
      valid = false;
      if(!this.deliveringValidationMessages)
        this.deliveringValidationMessages = [];
      this.deliveringValidationMessages.push('Quantity delivered cannot be greater than an items quantity.');
    }
    return valid;
  }
  
  async rereceiveOrder() {
    if(this.validateRereceiving())
    {
      this.rereceivingLoading = true;
      try {
        await barcodeOrderModuleState.rereceiveBarcodeOrder(
          this.rereceiveBarcodeOrderRequest
        );
        notifications.success("Barcode Order Rereceived", "Barcode Order successfully rereceived.");
        this.$emit("reload");
        this.closeModals();
      } catch (ex) {
        notifications.error("Rereceiving Barcode Order", "Failed to rereceive barcode orders", ex);
      } finally {
        this.rereceivingLoading = false;
      }
    }
  }
 
  validateRereceiving() : boolean {
    let valid = this.rereceiveBarcodeOrderRequest != null;
    this.rereceivingValidationMessages = null;

    if(!valid)
      return false;

    if(this.rereceiveBarcodeOrderRequest.orderItems.some(x => x.damaged && x.quantityDamaged <= 0)) {
      valid = false;
      if(!this.rereceivingValidationMessages)
        this.rereceivingValidationMessages = [];
      this.rereceivingValidationMessages.push('All damaged items must have a quantity damaged greater than 0.'); 
    }
    if(this.rereceiveBarcodeOrderRequest.orderItems.some(x => x.damaged && !x.damageCode)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.rereceivingValidationMessages = [];
      this.rereceivingValidationMessages.push('All damaged items must have a selected damage code.');
    }
    if(this.rereceiveBarcodeOrderRequest.orderItems.some(x => x.quantityReceived > x.quantity)) {
      valid = false;
      if(!this.rereceivingValidationMessages)
        this.rereceivingValidationMessages = [];
      this.rereceivingValidationMessages.push('Quantity received cannot be greater than an items quantity.');
    }
    return valid;
  }

  viewOrder(){
    this.$emit("viewOrder");
  }
}

